import { render, staticRenderFns } from "./AjouterModule.vue?vue&type=template&id=226295cd&scoped=true&"
import script from "./AjouterModule.vue?vue&type=script&lang=js&"
export * from "./AjouterModule.vue?vue&type=script&lang=js&"
import style0 from "./AjouterModule.vue?vue&type=style&index=0&id=226295cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226295cd",
  null
  
)

export default component.exports